<template>
  <div class="main-content berita">
    <section class="inner-header about-us">
      <div class="container pt-60 pb-70">
        <!-- Section Content -->
        <div class="section-content">
          <div class="row">
            <div class="col-md-12">
              <h2 class="title">Tips & Trik Kesehatan - [Nama Tips & Trik]</h2>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="news-container detail">
      <div class="container">
        <div class="row">
          <div class="col-md-12 col-md-offset-2">
            <div class="blog-posts single-post">
              <article class="post clearfix mb-0">
                <div class="entry-header">
                  <div class="post-thumb thumb">
                    <img
                      v-bind:src="JSON.parse(getArticlesContent(articles).meta).meta_picture"
                      alt
                      class="img-responsive img-fullwidth"
                    />
                  </div>
                </div>
                <div class="entry-content mt-20">
                  <div class="media-body">
                    <div class="event-content pull-left flip">
                      <h3
                        class="entry-title text-theme-colored text-uppercase pt-0 mt-0"
                      >{{ getArticlesContent(articles).slug }}</h3>
                      <div class="post-info mb-20">
                        <div class="author">{{ getArticlesContent(articles).user_name }}</div>
                        <div class="separator">|</div>
                        <div class="date">{{ getArticlesContent(articles).created_at }}</div>
                      </div>
                    </div>
                  </div>
                  <div v-html="JSON.parse(getArticlesContent(articles).meta).description"></div>
                  <div class="mt-30 mb-0">
                    <h5 class="pull-left mt-10 mr-20 text-theme-colored">Share:</h5>
                    <ul class="styled-icons icon-circled m-0">
                      <li>
                        <a href="#" class="fb">
                          <i class="fa fa-facebook text-white"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </article>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { ACTION_SET_ARTICLE } from "../store/repo/pages";

export default {
  created() {
    this.slug = this.$route.params.slug;
  },
  data() {
    return {};
  },
  mounted() {
    const payload = {
      slug: this.$route.params.slug,
    };
    this.$store.dispatch(ACTION_SET_ARTICLE, payload);
  },
  methods: {
    getArticlesContent(data) {
      return data;
    },
  },
  computed: {
    articles() {
      return this.$store.getters.getArticlesSingle.data == undefined
        ? []
        : this.$store.getters.getArticlesSingle.data;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/pages/TipsTrikDetail.vue